import { useGlobalState } from "Global";
import { useLocation, useMatch } from "react-router-dom";
import AssistantChatExperience from "./components/AssistantChatExperience";

const CHATBOT_LAUNCHER_ENABLED = true;

const ChatBotPopup = ({ routes }) => {
  const [userDetails] = useGlobalState("userDetails");
  const { pathname } = useLocation();
  const caseRouteMatch = useMatch("/cases/:case_id");
  const claimId = caseRouteMatch?.params?.case_id ?? null;
  const matchedPath = [];

  routes.forEach((route) => {
    if (route.showChatbot && route.path) {
      matchedPath.push(route.path);
    }
    if (route.path && route.subRoute) {
      route.subRoute.forEach((subRoute) => {
        if (subRoute.showChatbot && subRoute.path) {
          matchedPath.push(`${route.path}/${subRoute.path}`);
        }
      });
    }
  });

  const matches = matchedPath.map((path) => useMatch(path));
  const shouldShowChatbot = matches.some(
    (match) => match !== null || pathname === matchedPath.find((path) => path === pathname)
  );

  if (
    !CHATBOT_LAUNCHER_ENABLED ||
    userDetails?.permission !== "superuser" ||
    !shouldShowChatbot
  ) {
    return null;
  }

  return <AssistantChatExperience mode="popup" claimId={claimId} />;
};

export default ChatBotPopup;
